<!--
  Copyright 2024 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div [formGroup]="expressionControl" class="task-condition-form">
  <div>If the answer to</div>

  <mat-form-field>
    <mat-label>Select question</mat-label>

    <mat-select formControlName="taskId">
      <mat-option *ngFor="let task of previousMultipleTasks" [value]="task.id">
        {{task.label}}
      </mat-option>
    </mat-select>

    <mat-error *ngIf="taskIdControl.touched && taskIdControl.invalid">
      <ng-container *ngIf="taskIdControl.hasError('required')">
        A question must be selected as a condition
      </ng-container>
    </mat-error>
  </mat-form-field>

  <div>is</div>

  <mat-form-field>
    <mat-label>Select answer</mat-label>

    <mat-select formControlName="optionIds" multiple>
      <mat-option *ngFor="let option of previousMultipleTasks | getTaskOptions:taskIdControl.value" [value]="option.id">
        {{option.label}}
      </mat-option>
    </mat-select>

    <mat-error *ngIf="optionIdsControl.touched && optionIdsControl.invalid">
      <ng-container *ngIf="optionIdsControl.hasError('required')">
        At least one answer must be selected
      </ng-container>
    </mat-error>
  </mat-form-field>
</div>
